export default __webpack_public_path__ + "static/media/Ahmed Jamshed.4a7ad494.jpeg";